export const defaultMeta = {
  currentPage: 1,
  totalItems: 0,
  hasPrevPage: false,
  hasNextPage: false,
  pageSize: 10,
  totalPages: 0,
};
